<template v-slot:main>
	<Head>
		<Title>{{ pageTitle }} - Timothy Sykes</Title>
		<Link
			rel="canonical"
			:href="`${current_hostname}${$route.name}/`"
		/>
	</Head>
	<Layout>
		<div class="tim-section-default tim-section-light tim-section-top">
			<div class="inner">
				<header
					id="header"
					class="tim-site-header-homework"
					role="banner"
				>
					<ul class="tim-menu-homework">
						<li
							id="menu-item-27802"
							class="menu-item menu-item-type-post_type menu-item-object-page menu-item-27802 tim-menu-previous"
						>
							<nuxt-link
								to="/trading-hw-1/"
								aria-current="page"
								exact-active-class="active"
							>
								Application Received
								<span>Homework 1 of 5</span>
							</nuxt-link>
						</li>
						<li
							id="menu-item-27803"
							class="menu-item menu-item-type-post_type menu-item-object-page menu-item-27803 tim-menu-previous"
						>
							<nuxt-link
								to="/trading-hw-2/"
								exact-active-class="active"
							>
								The Keys To Success
								<span>Homework 2 of 5</span>
							</nuxt-link>
						</li>
						<li
							id="menu-item-27807"
							class="menu-item menu-item-type-post_type menu-item-object-page menu-item-27807 tim-menu-previous"
						>
							<nuxt-link
								to="/trading-hw-3/"
								exact-active-class="active"
							>
								Top 10 Effective Trading Tips
								<span>Homework 3 of 5</span>
							</nuxt-link>
						</li>
						<li
							id="menu-item-27805"
							class="menu-item menu-item-type-post_type menu-item-object-page menu-item-27805 tim-menu-previous"
						>
							<nuxt-link
								to="/trading-hw-4/"
								exact-active-class="active"
							>
								My Famous Interviews
								<span>Homework 4 of 5</span>
							</nuxt-link>
						</li>
						<li
							id="menu-item-35122"
							class="menu-item menu-item-type-post_type menu-item-object-page menu-item-35122 tim-menu-previous"
						>
							<nuxt-link
								to="/trading-hw-5/"
								exact-active-class="active"
							>
								Fortune Favors The Bold &nbsp;
								<span>Homework 5 of 5</span>
							</nuxt-link>
						</li>
						<li
							id="menu-item-27804"
							class="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-25438 current_page_item menu-item-27804"
						>
							<nuxt-link
								to="/trading-hw-bonus/"
								exact-active-class="active"
							>
								One Last Thought
								<span>Homework Bonus</span>
							</nuxt-link>
						</li>
					</ul>
				</header>
			</div>
		</div>
		<div class="page-content tim-homework-content">
			<div
				v-if="pageContent !== null"
				class="inner"
				v-html="pageContent"
			/>
			<div class="inner">
				<div class="tim-disclaimer">
					<p id="custom-paragraph">
						*Results are not typical and will vary from person to person. Making money
						trading stocks takes time, dedication, and hard work. There are inherent
						risks involved with investing in the stock market, including the loss of
						your investment. Past performance in the market is not indicative of
						future results. Any investment is at your own risk.
						<a
							class="custom-link"
							href="https://www.timothysykes.com/terms-of-service/"
						>
							See Terms of Service here
						</a>
						.
					</p>
				</div>
			</div>
		</div>
	</Layout>
</template>
<script setup>
import Layout from "~/components/layout/Loose.vue";

const { pageTitle, pageContent } = await useLegalPage('trading-hw-bonus');
</script>
<style scoped>
:deep(.custom-link) {
	background: none;
	padding: 0;
	color: #61a8ef;
	border: none;
	font-size: inherit;
	text-transform: none;
	text-decoration: none;
}

:deep(#homework) {
	align-items: center;
	text-align: center !important;
}
:deep(.inner) {
	text-align: center !important;
}
</style>
